export const MAX_GROUP_SIZE = 5;

export interface GroupMemberFormValues {
  ticket_type: string;
  ticket_value: number;
  name: string;
  email: string;
  cpf: string;
  phone: string;
  [key: string]: string | number;
}

export interface GroupFormValues {
  members: GroupMemberFormValues[];
  coupon_code: string;
}

export interface GroupMemberPayload {
  name: string;
  email: string;
  cpf: string;
  phone: string;
  ticket_type: string;
  ticket_value: number;
  dynamicAnswers: { dynamic_field_id: string; answer: string }[];
}

export interface GroupRegistrationPayload {
  event_id: string;
  members: GroupMemberPayload[];
  coupon_code?: string;
}

export interface GroupRegistrationResponse {
  group_id: string;
  principal_cpf: string;
  total_value: number;
  member_count: number;
  message: string;
}
